var $ = jQuery.noConflict(),
  wi = $(window).width();

/**
 * Function to show and hide map on listings
 *
 * return {void}
 */
function showHideMapFunction () {
  var show_map_visible = '.show-if-map-visible',
    hide_map_visible = '.hide-if-map-visible',
    show_map = '.show-map',
    list_visible = 'list-visible',
    data_show_map = 'show-map',
    data_show_list ='show-list',
    list_icon = '.show-map__icon--list',
    map_icon = '.show-map__icon--map',
    search_note = '.search-section--note',
    search_bar = '.search-section--sticky',
    load_more = '.listing-pagination';

  // Show map on listing
  $(show_map).off('click').on('click', function (e) {
    e.preventDefault();

    if (typeof google === 'undefined') {
      google_maps_loaded = false;
    }

    if (!google_maps_loaded) {
      $.getScript('https://maps.google.com/maps/api/js?key=' + $gmaps_api_key +'&language=en', function () {
        $.getScript(window.location.origin + '/vendor/google-maps-infobox/infobox-lib.js', function () {
          mainMap();
        });
      });
    } else {
      mainMap();
    }

    google_maps_loaded = true;
    $(show_map_visible).toggle();
    $(hide_map_visible).toggle();

    if ($(window).width() > 1024) {
      $(search_note).toggle();
      $(search_bar).toggle();
    }

    $(load_more).toggle();

    $('html, body').animate({
      scrollTop: $('#map-container').offset().top - $('.header-container').outerHeight() - 30
    }, 800);

    if($(show_map).hasClass(list_visible)) {
      $(show_map)
        .removeClass(list_visible);

      $(map_icon).show();
      $(list_icon).hide();

      $(show_map + ' > span')
        .text($(show_map)
        .data(data_show_map));

      return;
    }

    $(show_map)
      .addClass(list_visible);

    $(list_icon).show();
    $(map_icon).hide();

    $(show_map + ' > span')
      .text($(show_map)
        .data(data_show_list));

    //Center map on multiple markers
    //map.fitBounds(bounds);
    //map.panToBounds(bounds);

  });
}

function mainMap () {

  // Locations
  var ib = new InfoBox(),
    bounds = new google.maps.LatLngBounds(),
    mapZoomAttr = $('#map').attr('data-map-zoom'),
    mapScrollAttr = $('#map').attr('data-map-scroll'),
    zoomLevel = 10,
    scrollEnabled = false;

  if (typeof mapZoomAttr !== typeof undefined && mapZoomAttr !== false) {
    zoomLevel = parseInt(mapZoomAttr);
  }

  if (typeof mapScrollAttr !== typeof undefined && mapScrollAttr !== false) {
    scrollEnabled = parseInt(mapScrollAttr);
  }

  // Main Map
  map = new google.maps.Map(document.getElementById('map'), {
    zoom: zoomLevel,
    scrollwheel: scrollEnabled,
    center: new google.maps.LatLng(45.307074, 13.689940),
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    zoomControl: false,
    mapTypeControl: false,
    scaleControl: false,
    panControl: false,
    navigationControl: false,
    streetViewControl: false,
    gestureHandling: 'cooperative',
    styles: [{
      featureType: 'poi',
      elementType: 'labels',
      stylers: [{
        visibility: 'off'
      }]
    }]
  });

  // Marker highlighting when hovering listing item
  $('body').on('mouseover', '.listing-item-container', function () {

    var listingAttr = $(this).data('marker-id');

    if (listingAttr !== undefined) {
      var listing_id = $(this).data('marker-id');
      var marker_div = allMarkers[listing_id].div;

      $(marker_div).addClass('clicked');

      $(this).on('mouseout', function () {
        if ($(marker_div).is(':not(.infoBox-opened)')) {
          $(marker_div).removeClass('clicked');
        }
      });
    }

  });


  
  let lastCenter = null;
  let firstLoad = true;
  
  map.addListener('bounds_changed', function () {
    if ($('#snippet--searchResultsControl').length) {
        let newCenter = map.getCenter();
        let zoomLevel = map.getZoom();
        let threshold = getThresholdForZoom(zoomLevel);

        if (firstLoad) {
            firstLoad = false;
            lastCenter = newCenter;
            return;
        }

        let latDiff = Math.abs(newCenter.lat() - lastCenter.lat());
        let lngDiff = Math.abs(newCenter.lng() - lastCenter.lng());

        if (latDiff > threshold || lngDiff > threshold) {
            lastCenter = newCenter;
            fetchNewLocations(location.href);
        }
    }
  });

  function getQueryParams(url) {
    let params = new URL(url).searchParams;
    let queryParams = {};
    params.forEach((value, key) => {
      queryParams[key] = value;
    });
    return queryParams;
  }

  function modifyQueryParams(url, modifications = {}) {
    let baseUrl = url.split('?')[0];
    let params = new URLSearchParams(getQueryParams(url));

    Object.keys(modifications).forEach(key => {
      if (modifications[key] === null) {
        params.delete(key);
      } else {
        params.set(key, modifications[key]);
      }
    });

    return params.toString() ? `${baseUrl}?${params.toString()}` : baseUrl;
  }

  function cardSkeleton(action) {
    if(action === 'show') {
      $('.skeleton-element').addClass('skeleton-element--loading');
    }

    if(action === 'hide') {
      $('.skeleton-element').removeClass('skeleton-element--loading');
    }
  }

  let fetchTimeout;
  let latestRequestToken = 0; // Global counter to track latest request

  function fetchNewLocations(url) {
      clearTimeout(fetchTimeout); // Clear any pending request

      fetchTimeout = setTimeout(() => {
          let requestToken = ++latestRequestToken; // Increment and assign new token

          let { north, east, south, west } = updateMapData();
          let newParams = {
              "max_latitude": north,
              "min_latitude": south,
              "min_longitude": west,
              "max_longitude": east,
              "destination": null,
              "location_type": null,
              "location_code": null
          };

          let modifiedUrl = modifyQueryParams(url, newParams);
          addLoadingMarker();
          cardSkeleton('show');
          $('#location-search-input').val('');
          if ($('.select2-selection__choice span:nth-of-type(2)').text().trim() === '') {
              $('.select2-search__field').val($('.main-search-input--search-results').data('input-label'));
          } else {
              $('.select2-selection__choice span:nth-of-type(2)').html($('.main-search-input--search-results').data('input-label'));
          }
          $.ajax({
              url: modifiedUrl,
              method: 'GET',
              dataType: 'json',
              success: function(data) {
                  // Only process if this is the latest request
                  if (requestToken !== latestRequestToken) return;
                  let previousZoomLevel = map.getZoom();
                  mapData = data.mapInfo;
                  $('#snippet--searchResultsControl').html(data.snippets['snippet--searchResultsControl']);
                  $('#snippet--paginatorControl').html(data.snippets['snippet--paginatorControl']);
                  $('#snippet--resultsExists').html(data.snippets['snippet--resultsExists']);
                  $('.showing-results__content').text(function(_, text) {
                      return text.replace(/\d+/, mapData.length);
                  });

                  clearMarkers();
                  $('.loading-box-map').remove();
                  addMarkers(0, mapData.length, false);
                  map.setZoom(previousZoomLevel);
                  window.history.pushState({}, '', modifiedUrl);
                  keenCarousel();
                  magnificPopupInit();
                  flatpickrCalendarsInquiry();

                  $('#max_latitude').val(north);
                  $('#min_latitude').val(south);
                  $('#max_longitude').val(east);
                  $('#min_longitude').val(west);

                  $('.panel-apply').removeClass('button-disabled');

                  if (mapData.length > 0) {
                      let label = $('.panel-apply').data('available-label');
                      label = label.replace(/(\d+)/, mapData.length);
                      $('.panel-apply').text(label);
                  } else {
                      $('.panel-apply').text($('.panel-apply').data('unavailable-label'));
                  }
              },
              error: function(xhr, status, error) {
                  // Also ignore errors from outdated requests
                  if (requestToken !== latestRequestToken) return;
                  $('.loading-box-map').remove();
                  console.error('Error fetching new locations:', error);
              }
          });
      }, 200); // Adjust debounce delay as needed
  }



  // Function to clear existing markers
  function clearMarkers() {
    for (let i = 0; i < allMarkers.length; i++) {
      if (allMarkers[i]) {
        allMarkers[i].setMap(null);
      }
    }
    allMarkers = [];
  }
  
  // Function to get threshold dynamically based on zoom level
  function getThresholdForZoom(zoom) {
    if (zoom >= 10) return 0.015; // Keep a slightly higher threshold at extreme zooms
    let zoomFactor = Math.pow(2, (15 - zoom)) * 0.009;
    return Math.max(zoomFactor, 0.002); // Set a higher minimum threshold
  }
  
  function updateMapData() {
    let bounds = map.getBounds();
    if (!bounds) return;

    let north = bounds.getNorthEast().lat(); // Top
    let east = bounds.getNorthEast().lng(); // Right
    let south = bounds.getSouthWest().lat(); // Bottom
    let west = bounds.getSouthWest().lng(); // Left

    return {north, east, south, west};
  }


  // Infobox
  var boxText = document.createElement('div'),
    customBoxText = '.custom-infobox',
    customBoxContainer = '.custom-infobox-container',
    currentInfobox,
    boxOptions = {
      content: boxText,
      disableAutoPan: false,
      alignBottom : true,
      maxWidth: 0,
      pixelOffset: new google.maps.Size(-125, -18),
      zIndex: null,
      boxStyle: {
        width: '250px'
      },
      closeBoxMargin: '0',
      closeBoxURL: '',
      infoBoxClearance: new google.maps.Size(25, 25),
      isHidden: false,
      pane: 'floatPane',
      enableEventPropagation: false
    },
    allMarkers = [],
    clusterStyles = [
      {
        textColor: 'white',
        url: '',
        height: 50,
        width: 50
      }
    ];

  boxText.className = 'map-box';

  function locationData (locationURL, locationImg, locationTitle, locationAddress, bedrooms, surface, capacity, min_price, total_price, poolType, poolSize) {
    var pool = '(' + poolSize + 'm<sup>2</sup>' + ')',
      price_text = '',
      price = 0;

    if (total_price === null || typeof total_price === 'undefined') {
      price_text = from_text;
      price = price_text + ' ' + min_price + ' &euro;';
    } else {
      price_text = total_price_text;
      price = total_price + ' &euro;';
    }

    if (poolSize === 0 || !poolSize) {
      pool = '';
    }

    if (poolType === undefined) {
      poolType = '';
    }

    if (wi > 768) {
      return ('' +
        '<a href="' + locationURL + '" target="_blank" class="listing-img-container list-gmap">' +
        '<div class="infoBox-close"></div>' +
        '<img height="160" class="lazyload" src="#" data-src="' + locationImg + '" alt="' + locationTitle + '">' +
        '</a>' +

        '<div class="listing-content">' +
        '<div class="listing-title">' +
        '<div class="listing-item-content">' +
        '<h3 class="default-font"><a href="' + locationURL + '" target="_blank">' + locationTitle + '</a></h3>' +
        '<p class="listing-item-location">' + locationAddress + '</p>' +
        '</div>' +
        '<ul class="map-features">' +
        '<li>' + bedrooms_text + ': <strong>' + bedrooms + '</strong></li>' +
        '<li>' + people_text + ': <strong>' + capacity + '</strong></li>' +
        '<li>' + poolType + ' <strong>' + pool + '</strong></li>' +
        '</ul>' +
        '<p class="listing-price">' + price + '</p>' +
        '</div>' +
        '</div>');
    } else {
      return ('' +
        '<div class="infoBox-close"></div>' +
        '<a href="' + locationURL + '" target="_blank" class="listing-img-container list-gmap">' +
        '<img height="160" class="lazyload" src="#" data-src="' + locationImg + '" alt="' + locationTitle + '">' +
        '</a>' +

        '<div class="listing-content">' +
        '<div class="listing-title">' +
        '<h3 class="default-font"><a href="' + locationURL + '" target="_blank">' + locationTitle + '</a></h3>' +
        '<p class="listing-item-location">' + locationAddress + '</p>' +
        '<ul class="map-features">' +
        '<li>' + surface + 'm<sup>2</sup></strong></li>' +
        '<li>' + bedrooms_text + ': <strong>' + bedrooms + '</strong></li>' +
        '<li>' + people_text + ': <strong>' + capacity + '</strong></li>' +
        '<li>' + poolType + ' <strong>' + pool + '</strong></li>' +
        '</ul>' +
        '<p class="listing-price">' + price + '</p>' +
        '</div>' +
        '<a href="' + locationURL + '" target="_blank" class="listing-single-page"></a>' +
        '</div>');
    }
  }

  function addMarkers (start, end, shouldMapFitBounds = true) {
    for (var i = start; i < end; i++) {
      if (!mapData[i].latitude) {
        continue;
      }

      var overlaypositions = new google.maps.LatLng(mapData[i].latitude, mapData[i].longitude),
        mapMarkerPrice = 0;

      if (mapData[i].total_price === null || typeof mapData[i].total_price === 'undefined') {
        mapMarkerPrice = mapData[i].min_price_no_format;
      } else {
        mapMarkerPrice = mapData[i].total_price_no_format;
      }

      var overlay = new CustomMarker(
        overlaypositions,
        map,
        {
          marker_id: mapData[i].product_id
        },
        '<i class="icon icon-box">' + mapMarkerPrice + '&euro;</i>'
      );

      bounds.extend(overlaypositions);
      allMarkers[mapData[i].product_id] = overlay;

      //Center map on multiple markers
      if(shouldMapFitBounds) {
        map.fitBounds(bounds);
        map.panToBounds(bounds);
      }

      google.maps.event.addListenerOnce(map, 'idle', function() {
        if (map.getZoom() > 13) map.setZoom(13);
      });

      google.maps.event.addListener(overlay, 'click', (function (overlay, i) {

        return function () {
          if (wi > 768) {
            ib.setOptions(boxOptions);
            boxText.innerHTML = locationData(
              presenterLanguage + mapData[i].slug,
              mapData[i].picture ? mapData[i].picture : '',
              mapData[i].title,
              mapData[i].subregion + ', ' + mapData[i].region + ' (' + mapData[i].country + ')',
              mapData[i].bedroom ? mapData[i].bedroom : '',
              '',
              mapData[i].people_number,
              mapData[i].min_price,
              mapData[i].total_price,
              mapData[i].pool_type,
              mapData[i].pool_size
            );

            ib.close();
            ib.open(map, overlay);
            currentInfobox = 1;

            google.maps.event.addListener(ib, 'domready', function () {
              $('.infoBox-close').click(function (e) {
                e.preventDefault();
                ib.close();
                $('.map-marker-container').removeClass('clicked infoBox-opened');
              });
            });
          } else {
            $(customBoxContainer).show();
            $(customBoxText).html(locationData(
              presenterLanguage + mapData[i].slug,
              mapData[i].picture ? mapData[i].picture : '',
              mapData[i].title,
              mapData[i].subregion + ', ' + mapData[i].region + ' (' + mapData[i].country + ')',
              mapData[i].bedroom ? mapData[i].bedroom : '',
              mapData[i].surface,
              mapData[i].people_number,
              mapData[i].min_price,
              mapData[i].total_price,
              mapData[i].pool_type,
              mapData[i].pool_size
            ));
            $('.infoBox-close').on('click', function (e) {
              e.preventDefault();
              $('.custom-infobox-container').hide();
            });
          }
        }
      })(overlay, i));

    }
  }

// function for adding loading markers random on the map
function addLoadingMarker() {
    $('#map-container').append(      
      `<div class="loading-box-map">
      <div class="loading-dot-listing-map"></div>
      <div class="loading-dot-listing-map"></div>
      <div class="loading-dot-listing-map"></div>
    </div>`
  );
}

  // Marker Clusterer Init
  var options = {
    imagePath: 'images/',
    styles : clusterStyles,
    minimumClusterSize: 6
  };

  window.addEventListener('resize', () => {
    var center = map.getCenter();
    google.maps.event.trigger(map, 'resize');
    map.setCenter(center);
    map.fitBounds(bounds);
    map.panToBounds(bounds);
  });
  let oldZoom = map.getZoom();
  let isFirstLoad = true;
  google.maps.event.addListener(map, 'zoom_changed', function () {
    var getZoomLevel = map.getZoom(),
      mapPin = $('.icon-house-map-pin');
    if (getZoomLevel >= 13) {
      mapPin.addClass('icon-bigger');
    } else if (getZoomLevel <= 9) {
      mapPin.addClass('icon-smaller')
    } else {
      mapPin.removeClass('icon-bigger icon-smaller');
    }

    if (getZoomLevel < oldZoom && !isFirstLoad) {
      oldZoom = getZoomLevel;
      if ($('#snippet--searchResultsControl').length) {
        fetchNewLocations(location.href);
      }
    }
    isFirstLoad = false;
  });

  // Custom User Interface Elements

  // Custom Zoom-In and Zoom-Out Buttons
  var zoomControlDiv = document.createElement('div'),
    zoomControl = new ZoomControl(zoomControlDiv, map);

  function ZoomControl (controlDiv, map) {
    zoomControlDiv.index = 1;
    map.controls[google.maps.ControlPosition.RIGHT_CENTER].push(zoomControlDiv);
    // Creating divs & styles for custom zoom control
    controlDiv.style.padding = '5px';
    controlDiv.className = 'zoomControlWrapper';

    // Set CSS for the control wrapper
    var controlWrapper = document.createElement('div');
    controlDiv.appendChild(controlWrapper);

    // Set CSS for the zoomIn
    var zoomInButton = document.createElement('div');
    zoomInButton.className = 'custom-zoom-in';
    controlWrapper.appendChild(zoomInButton);

    // Set CSS for the zoomOut
    var zoomOutButton = document.createElement('div');
    zoomOutButton.className = 'custom-zoom-out';
    controlWrapper.appendChild(zoomOutButton);

    // Setup the click event listener - zoomIn
    zoomInButton.addEventListener('click', () => {
      map.setZoom(map.getZoom() + 1);
    });

    // Setup the click event listener - zoomOut
    zoomOutButton.addEventListener('click', () => {
      map.setZoom(map.getZoom() - 1);
    });
  }

  // Scroll enabling button
  $('body').on('click', '#scrollEnabling', function (e) {
    e.preventDefault();
    $(this).toggleClass('enabled');

    if ($(this).is('.enabled')) {
      map.setOptions({'scrollwheel': true});
    } else {
      map.setOptions({'scrollwheel': false});
    }
  });

  function CustomMarker (latlng, map, args, markerIco) {
    this.latlng = latlng;
    this.args = args;
    this.markerIco = markerIco;
    this.setMap(map);
  }

  CustomMarker.prototype = new google.maps.OverlayView();
  CustomMarker.prototype.draw = function () {
    var self = this,
      div = this.div;

    if (!div) {
      div = this.div = document.createElement('div');
      div.className = 'map-marker-container';

      div.innerHTML = '<div class="marker-container">'+
        '<div class="marker-card">'+
        '<div class="front face">' + self.markerIco + '</div>'+
        '</div>'+
        '</div>';

      // Clicked marker highlight
      div.addEventListener('click', () => {
        if (!$(this).hasClass('infoBox-opened')) {
          $('.map-marker-container').removeClass('clicked infoBox-opened');
          $(this).addClass('clicked infoBox-opened');

          setTimeout(function () {
            google.maps.event.trigger(self, 'click');
          }, 50);
        }
      });

      if (typeof(self.args.marker_id) !== 'undefined') {
        div.dataset.marker_id = self.args.marker_id;
      }

      var panes = this.getPanes();
      panes.overlayImage.appendChild(div);
    }

    var point = this.getProjection().fromLatLngToDivPixel(this.latlng);

    if (point) {
      div.style.left = (point.x) + 'px';
      div.style.top = (point.y) + 'px';
    }
  };

  CustomMarker.prototype.remove = function () {
    if (this.div) {
      this.div.parentNode.removeChild(this.div);
      this.div = null; $(this).removeClass('clicked');
    }
  };

  CustomMarker.prototype.getPosition = function () {
    return this.latlng;
  };

  setTimeout(function () {
    addMarkers(0, mapData.length);
  }, 1);
}

$(document).ready(function () {
  // Map Init
  var map = document.getElementById('map');

  if (typeof(map) != 'undefined' && map != null && !load_on_demand) {
    window.addEventListener('load', () => { mainMap(); });
  }

  showHideMapFunction();
});
